export const themesStoreKeys = {
    themeKey: 'tonLiveTheme',
};
